'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InlineCommentEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseAlerts = require('@bibliocommons/base-alerts');

var _simpleUgcDisplay = require('../../simple-ugc-display');

var _simpleUgcDisplay2 = _interopRequireDefault(_simpleUgcDisplay);

var _simpleUgcForm = require('../../simple-ugc-form');

var _simpleUgcForm2 = _interopRequireDefault(_simpleUgcForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InlineCommentEditor = exports.InlineCommentEditor = function (_BcReactComponent) {
  _inherits(InlineCommentEditor, _BcReactComponent);

  function InlineCommentEditor(props) {
    _classCallCheck(this, InlineCommentEditor);

    var _this = _possibleConstructorReturn(this, (InlineCommentEditor.__proto__ || Object.getPrototypeOf(InlineCommentEditor)).call(this, props));

    _this.state = {
      focusInput: false
    };
    return _this;
  }

  _createClass(InlineCommentEditor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {/* for testing purposes */}
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.showForm && nextProps.showForm) {
        this.setState({
          focusInput: true
        });
      }
    }
  }, {
    key: 'renderMessaging',
    value: function renderMessaging() {
      var _props = this.props,
          status = _props.status,
          pending = _props.pending;

      var infoMessage = _react2.default.createElement(
        _baseAlerts.AlertInfo,
        null,
        _react2.default.createElement('span', { className: 'icon-spinner' }),
        'Submitting comment...'
      );
      var successMessage = _react2.default.createElement(
        _baseAlerts.AlertSuccess,
        null,
        'Comment Saved'
      );
      var failureMessage = _react2.default.createElement(
        _baseAlerts.AlertFailure,
        null,
        _react2.default.createElement('span', { className: 'icon-ok' }),
        'Could not save comment.'
      );

      return _react2.default.createElement(
        'div',
        null,
        pending ? infoMessage : null,
        status === 'success' ? successMessage : null,
        status === 'failure' ? failureMessage : null
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          characterLimit = _props2.characterLimit,
          comment = _props2.comment,
          fieldErrors = _props2.fieldErrors,
          handleCancel = _props2.handleCancel,
          handleChange = _props2.handleChange,
          handleDelete = _props2.handleDelete,
          handleShowForm = _props2.handleShowForm,
          handleSubmit = _props2.handleSubmit,
          handlePrivacyToggle = _props2.handlePrivacyToggle,
          bibId = _props2.bibId,
          isPrivate = _props2.isPrivate,
          rating = _props2.rating,
          showForm = _props2.showForm,
          user = _props2.user;


      if (showForm) {
        return _react2.default.createElement(
          'div',
          { className: 'cp-inline-comment-editor well clearfix' },
          this.renderMessaging(),
          _react2.default.createElement(_simpleUgcForm2.default, {
            fieldErrors: fieldErrors,
            errorKey: 'comment',
            characterLimit: characterLimit,
            body: comment,
            ugcType: 'comment',
            handleDelete: handleDelete,
            handleCancel: handleCancel,
            handleChange: handleChange,
            handleSubmit: handleSubmit,
            setFocus: this.state.focusInput,
            formHeadingText: 'enter_a_comment',
            placeholderText: 'comment_field_placeholder',
            submitButtonText: 'update_comment' })
        );
      }

      return _react2.default.createElement(
        'div',
        null,
        this.renderMessaging(),
        _react2.default.createElement(_simpleUgcDisplay2.default, {
          user: user,
          ugcType: 'comment',
          body: comment,
          rating: rating / 2,
          bibId: bibId,
          isPrivate: isPrivate,
          handleDelete: handleDelete,
          handleShowForm: handleShowForm,
          handlePrivacyToggle: handlePrivacyToggle })
      );
    }
  }]);

  return InlineCommentEditor;
}(_baseBcReactComponent2.default);

InlineCommentEditor.propTypes = {
  characterLimit: _react.PropTypes.number,
  comment: _react.PropTypes.string,
  fieldErrors: _react.PropTypes.objectOf(_react.PropTypes.shape({
    classification: _react.PropTypes.string,
    message: _react.PropTypes.string
  })),
  handleCancel: _react.PropTypes.func.isRequired,
  handleChange: _react.PropTypes.func.isRequired,
  handleDelete: _react.PropTypes.func.isRequired,
  handleShowForm: _react.PropTypes.func.isRequired,
  handleSubmit: _react.PropTypes.func.isRequired,
  handlePrivacyToggle: _react.PropTypes.func.isRequired,
  bibId: _react.PropTypes.number.isRequired,
  isPrivate: _react.PropTypes.bool.isRequired,
  pending: _react.PropTypes.bool.isRequired,
  rating: _react.PropTypes.number,
  user: _react.PropTypes.shape({
    loggedIn: _react.PropTypes.bool
  }).isRequired,
  showForm: _react.PropTypes.bool.isRequired,
  status: _react.PropTypes.string.isRequired
};

exports.default = (0, _reactIntl.injectIntl)(InlineCommentEditor);


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/shared/ugc-editors/lib/components/inline-comment-editor/components/InlineCommentEditor.js
// module id = 1021
// module chunks = 4